// import React from 'react';
// import {Link} from 'react-router-dom';

// const IconLink = ({title, children, className})=> (
//   <div className={`icon-link ${className || ''}`}>
//     {title && <span className="social-title">{title}</span>}
//     {children}
//   </div>
// );

// IconLink.Item = ({path, icon})=> (
//   <Link to={path || '#'}><i className={icon} target="_blank" rel="noopener noreferrer"/></Link>
// );

// export default IconLink;
import React from "react";
import { Link } from "react-router-dom";

const IconLink = ({ title, children, className }) => (
  <div className={`icon-link ${className || ""}`}>
    {title && <span className="social-title">{title}</span>}
    {children}
  </div>
);

IconLink.Item = ({ path, icon, target, rel }) => {
  const isExternal = path?.startsWith("http");

  if (isExternal) {
    return (
      <a href={path} target={target || "_self"} rel={rel || "noopener noreferrer"}>
        <i className={icon} />
      </a>
    );
  }

  return (
    <Link to={path || "#"}>
      <i className={icon} />
    </Link>
  );
};

export default IconLink;
